import { rem } from 'polished';
import NavigationLink from './NavigationLink';
import React from 'react';
import navigationConfig from './navigationConfig';
import styled from 'styled-components';
const PositionWrapper = styled.div `
  position: absolute;
  top: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  left: ${({ theme }) => rem(theme.navigation.shrunkWidth)};
  width: ${rem(240)};
  z-index: ${navigationConfig.BASE_ZINDEX + 1};
  padding: 0 0 ${({ theme }) => rem(theme.navigation.verticalPadding)} 0;
`;
const Pusher = styled.div `
  flex-shrink: 1;
  height: ${({ $position }) => rem($position)};
`;
const Wrapper = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 0 0 auto;
  max-height: 100%;

  background: ${({ theme }) => theme.navigation.backgroundColor};
  box-shadow: 0 0 4px 1px rgba(0, 0, 0, 0.08);
  border-radius: ${rem(4)};
  .${navigationConfig.ITEM_LINK_CLASS_NAME} {
    padding: ${rem(8)} ${rem(16)} !important;
  }
  .${navigationConfig.SUB_ITEM_LINK_CLASS_NAME} {
    padding: ${rem(8)} ${rem(16)} !important;
  }
`;
const InnerWrapper = styled.div `
  overflow-y: auto;
  padding: ${rem(8)} 0;
  border-top: 1px solid ${({ theme }) => theme.separatorColor};
`;
const ItemPopup = ({ label, renderLink, active, onClick, url, children, icon, position, subitems, onMouseEnter, onMouseLeave, }) => {
    return (React.createElement(PositionWrapper, null,
        React.createElement(Pusher, { "$position": position }),
        React.createElement(Wrapper, { onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
            React.createElement(NavigationLink, { renderLink: renderLink, forceInteractive: false, onClickItem: onClick, subitems: subitems, icon: icon, label: label, active: active, url: url, onClick: onClick, className: navigationConfig.ITEM_LINK_CLASS_NAME }, label),
            children && React.createElement(InnerWrapper, null, children))));
};
export default ItemPopup;
